var render, staticRenderFns
import script from "./DeliveryRoutePage.vue?vue&type=script&lang=ts&"
export * from "./DeliveryRoutePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryRoutePage.vue"
export default component.exports